import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UnifiedSidebar } from "./unified-sidebar";
import { SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import AIChatAgent from "@/components/ai-chat-agent";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const SIDEBAR_WIDTH = 400;

// Mobile Header Component
function MobileHeader() {
  const { setMobileOpen, mobileOpen } = useSidebar();

  const toggleSidebar = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 px-4 py-3">
      <div className="flex items-center justify-between">
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleSidebar}
          className="p-2"
        >
          {mobileOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>
        <h1 className="text-lg font-semibold">Dashboard</h1>
        <div className="w-9" /> {/* Spacer for centering */}
      </div>
    </div>
  );
}

export function DashboardLayout() {
  const location = useLocation();
  const [chatOpen, setChatOpen] = useState(false);

  // Determine which app we're in based on the route
  // PerkPoint routes start with /perkpoint
  // XpandPoint routes start with /xpandpoint
  // RewardPoint routes start with /rewardpoint
  // GiftCard routes start with /giftcard
  // Offer Point routes start with /offers
  // Everything else is Access Point (including root /)
  let app;
  switch (true) {
    case location.pathname.startsWith("/gamepoint"):
      app = "gamepoint";
      break;
    case location.pathname.startsWith("/perkpoint"):
      app = "perkpoint";
      break;
    case location.pathname.startsWith("/xpandpoint"):
      app = "xpandpoint";
      break;
    case location.pathname.startsWith("/rewardpoint"):
      app = "rewardpoint";
      break;
    case location.pathname.startsWith("/giftcard"):
      app = "giftcard";
      break;
    case location.pathname.startsWith("/offers"):
      app = "offers";
      break;
    case location.pathname.startsWith("/accesspoint"):
      app = "accesspoint";
      break;
    default:
      app = "accesspoint";
  }

  return (
    <SidebarProvider defaultExpanded={true}>
      <div
        style={{ height: "100vh" }}
        className="min-h-screen w-full flex bg-gray-50"
      >
        <MobileHeader />
        <UnifiedSidebar app={app} />
        <div
          style={{
            height: "100vh",
            overflow: "auto",
            transition: "margin-right 0.3s",
            marginRight: chatOpen ? SIDEBAR_WIDTH : 0,
          }}
          className="flex-1 p-5 lg:p-7 pt-16 lg:pt-5"
        >
          <Outlet />
        </div>
        <AIChatAgent open={chatOpen} onOpenChange={setChatOpen} />
      </div>
    </SidebarProvider>
  );
}
